	
window.loginTimer = null;